	
window.loginTimer = null;